<template>
    <b-modal id="detail_delete" ref="detail_delete" header-class="no-border" footer-class="no-border"
             @hidden="$emit('close')"
             :title="'Delete ' + this.detail.data.attributes.code + '?'">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('detail_delete')" v-text="'Cancel'"/>

            <state-button size="sm" variant="danger" :click="deleteDetail">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";

export default {
    name: "DetailDeleteModal",

    components: {
        StateButton
    },

    props: [
        'detail'
    ],

    methods: {
        hideModal(refname) {
            this.$refs[refname].hide();
        },

        deleteDetail() {
            return new Promise((success, fail) => {
                this.$store.dispatch('deleteInspectionDetail', this.detail)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('deleted-detail');

                            this.$notify('error filled', 'Success!', 'Deleted the detail!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('detail_delete');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
